import { localStorageRemove, localStorageSet } from '@Infra/LocalStorage';
import { LOCAL_STORAGE_KEYS } from '@Infra/LocalStorage/keys';

/**
 * Synchronous, not a thunk: this is a purely local device preference, mirrored straight into
 * `CurrentFacilityProvider`'s own state — there is no server round-trip and no store slice tracking
 * it, so there is no Action to dispatch. `null` purges the key instead of writing a sentinel value,
 * which is what lets a stale identifier from a former assignment stop resurfacing on a later visit.
 */
const recordCurrentFacility = (facilityId: number | null): void => {
	if (facilityId === null) {
		localStorageRemove(LOCAL_STORAGE_KEYS.CURRENT_FACILITY_ID);
		return;
	}

	localStorageSet(LOCAL_STORAGE_KEYS.CURRENT_FACILITY_ID, String(facilityId));
};

export default recordCurrentFacility;
